<div
    class="d-flex flex-column overflow-auto my-3 p-3 rounded articles-container position-relative"
    [style.background]="'url(' + article.imageUrl + ')'"
    data-uit="article"
>
    <div class="flex-grow-1">
        <h4 *ngIf="article.category" class="category mb-3">{{ article.category }}</h4>
        <h3 class="mb-3" data-uit="article-title">{{ article.title }}</h3>
        <p class="description">{{ article.description }}</p>
    </div>
    <div>
        <button type="button" *ngIf="article.actionUrl" (click)="triggerAction(article.actionUrl)" class="btn btn-primary action-button">
            {{ article.action }}
        </button>
    </div>
</div>
